<template>
  <div>
    <b-row class="mr-0">
      <b-col
        md="12"
        sm="12"
        cols="12"
        class="mb-5 mx-0 d-flex pr-0"
        v-for="(attachment, index) in attachments"
        :key="index"
      >
        <div
          v-if="!isImage(attachment)"
          class="box-container bg--primary-light d-flex align-items-center justify-content-center"
        >
          <template v-if="!isFile(attachment)">
            <a
              :href="attachment.attachment.attachmentFile"
              target="_blank"
              v-if="attachment.attachment.filetype === 'pdf'"
            >
              <h1 class="font-lg primary--text font-family-medium">
                {{ attachment.attachment.filetype.toUpperCase() }}
              </h1>
            </a>
            <a
              :download="attachment.attachment.name"
              :title="attachment.attachment.name"
              :href="attachment.attachment.attachmentFile"
              v-else
            >
              <h1 class="font-lg primary--text font-family-medium">
                {{ attachment.attachment.filetype.toUpperCase() }}
              </h1>
            </a>
          </template>
          <h1 v-else class="font-lg">
            <a
              :href="URL.createObjectURL(attachment)"
              target="_blank"
              class="primary--text font-family-medium"
              v-if="getFileExtension(attachment) === 'PDF'"
            >
              {{ getFileExtension(attachment) }}</a
            >
            <a
              :title="attachment.name"
              class="primary--text font-family-medium"
              :href="URL.createObjectURL(attachment)"
              :download="attachment.name"
              v-else
            >
              {{ getFileExtension(attachment) }}
            </a>
          </h1>
        </div>
        <div
          @click="onThumbnailClick(attachment, index)"
          v-else
          class="box-container bg--primary-light d-flex align-items-center justify-content-center thumbnail-wrapper"
        >
          <img
            :src="attachment.attachment.thumbnail"
            v-if="attachment.attachment"
          />
          <img :src="URL.createObjectURL(attachment)" v-else />
        </div>
        <div
          class="col d-flex flex-column w-50 justify-content-center text-align-center"
        >
          <p
            class="secondary--text font-family-regular font-size-md position-relative attachment-text"
            v-if="attachment.attachment"
          >
            {{ attachment.attachment.filename }}
          </p>
          <p class="primary--text font-family-medium" v-if="attachment.name">
            {{ attachment.name }}
          </p>
          <div>
            <b-button
              class="btn-pill btn-danger px-4 attachment-delete-btn"
              @click="deleteAttachment(index, attachment)"
              :disabled="!isFormEnabled"
            >
              Delete
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal
      size="lg"
      centered
      v-model="previewModal.visible"
      content-class="preview-modal"
      :hide-header="true"
      :hide-footer="true"
    >
      <div class="preview-modal-header">
        <div class="header-text">{{ previewModalData.title }}</div>
        <b-button
          id="delete-button"
          @click="onDeleteImage"
          :disabled="!isFormEnabled"
          >Delete</b-button
        >
        <b-button
          id="download-button"
          @click="onPreviewModalDownload"
          >Download</b-button
        >
        <b-button id="close-button" @click="previewModal.visible = false">
          <img src="@/assets/icons/close_sidebar.svg" />
        </b-button>
        <a
          :href="previewModalData.src"
          :title="previewModalData.title"
          :download="previewModalData.title"
          :style="{ display: 'none' }"
          ref="downloadAnchor"
        ></a>
      </div>
      <div class="preview-modal-image-wrapper">
        <img :src="previewModalData.src" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { isImage } from "@/utils/utils";
export default {
  name: "AttachmentsComponent",
  props: ["attachments", "isFormEnabled"],
  data() {
    return {
      previewModal: {
        visible: false,
        src: "",
        attachment: null
      },
      URL: window.URL
    };
  },
  computed: {
    previewModalData() {
      let { previewModal } = this;
      if (!previewModal.attachment) {
        return {
          src: "",
          title: "",
          thumbnail: ""
        };
      }
      if (previewModal.attachment instanceof File) {
        let blobUrl = window.URL.createObjectURL(previewModal.attachment);
        return {
          src: blobUrl,
          title: previewModal.attachment.name,
          thumbnail: blobUrl
        };
      }
      return {
        src: previewModal.attachment.attachment.attachmentFile,
        title: previewModal.attachment.attachment.filename,
        thumbnail: previewModal.attachment.attachment.thumbnail
      };
    }
  },
  methods: {
    isImage,
    isFile(attachment) {
      return attachment instanceof File;
    },
    getFileExtension(attachment) {
      let tokens = attachment.name.split(".");
      return tokens[tokens.length - 1].toUpperCase();
    },
    onPreviewModalDownload() {
      // forcibly download the file
      this.$refs.downloadAnchor.click();
    },
    onThumbnailClick(attachment, attachmentIndex) {
      this.previewModal.attachment = attachment;
      this.previewModal.attachmentIndex = attachmentIndex;
      this.previewModal.visible = true;
    },
    deleteAttachment(index, attachment) {
      this.$emit("deleteAttachment", [attachment, index]);
    },
    onDeleteImage() {
      let { attachmentIndex } = this.previewModal;
      this.$emit("deleteImage", attachmentIndex);
      this.previewModal.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
.breadcrumb-container-left {
  left: 0;
}
.customer-details {
  right: 2%;
  overflow-wrap: break-word;
}
.preferences-card-wrapper {
  margin-bottom: 5rem;
  padding-right: 1.5rem;
}
.preferences-categories-card {
  border-radius: 10px;
}
.sidebar-preferences-wrapper {
  margin-bottom: 10rem;
}
.add-attachment-top {
  top: 0.8rem;
  // border: 1px solid #dcebf4 !important;
}
.tasks-attachment-card {
  width: inherit;
  border: 1px solid #dcebf4 !important;
  height: 4rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.high-priority-text {
  margin: 2px;
}
.tasks-form-card {
  height: 4rem;
}
.comment-card-body {
  width: 30rem;
}
.tasks-vertical-divider {
  border-left: 1px solid $primary-lighter;
  top: 3rem;
}
.add-comment-input-box {
  height: 4rem;
  min-height: 4.4rem;
}
.remove-option-icon {
  right: 0.5rem;
}
.start-timer-btn {
  padding: 1rem 2rem !important;
}
.start-timer-btn p,
.timer-running-container p {
  // line-height: 1.8rem !important;
  color: #784f89;
  top: 1.3rem;
}

.checkbox-title-container {
  z-index: 0;
  top: 0.2rem;
}

.attachment-name {
  font-size: 1.5rem !important;
}

.show-timer p {
  top: 1.2rem;
}
.attachment-delete-btn,
.checklist-delete-btn {
}
.checklist-options-container {
  // height: 3rem;
  margin-bottom: 2.4rem;
}

.tasks-dropdown-divider {
  margin-top: 2.5rem;
}

.tasks-right-container {
  position: fixed;
  right: 0;
  z-index: 2;
  display: flex;
  // max-width: 21.66%;
  // flex: 0 0 21.66%;
  // width: 21.6%;
  top: 9rem;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
}
.input-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.box-container {
  height: 10rem;
  border-radius: 6px;
  // padding: 2rem;
  width: 15rem;
}

.show-timer-container {
  margin-top: -6rem;
}

.box-container a {
  opacity: 0.3;
}
.box-container.thumbnail-wrapper {
  > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.carousel-outer-container p {
  margin-top: 1rem;
}
.tasks-preferences {
  z-index: 100000;
  width: inherit;
}
.timer-resume {
  right: -1.5px;
  cursor: pointer;
}
.tasks-textarea {
  min-height: 17rem !important;
}
.status-field {
  margin-top: 40px;
}
.checklist-title-input {
  width: 80%;
  z-index: 5;
}
.checklist-title {
  z-index: 2;
  cursor: pointer;
}
.checklist-option-input-wrapper {
  flex: 1;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.save-button-row {
  padding-left: 30px;
  .save-button {
    background: $button-secondary;
  }
}
@media screen and (max-width: 991px) {
  .add-task-container {
    left: 0;
    width: 100%;
  }
  .add-task-container,
  .view-task-container {
    top: 18rem;
  }
}
@media screen and (max-width: 599px) {
  .add-task-container {
    height: 100vh;
  }
}
</style>
